export default __webpack_public_path__ + "media/images/hero-curve-8aae58b09db26d3e7f8f20b115511e3f.svg";